import { z } from "zod";

export const scanToTriggerConfigurationSchema = z.object({
	triggerField: z.string().optional(),
});
